import { render, staticRenderFns } from "./NotificationDetailSkeleton.vue?vue&type=template&id=1766e89f&scoped=true"
import script from "./NotificationDetailSkeleton.vue?vue&type=script&lang=js"
export * from "./NotificationDetailSkeleton.vue?vue&type=script&lang=js"
import style0 from "./NotificationDetailSkeleton.vue?vue&type=style&index=0&id=1766e89f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1766e89f",
  null
  
)

export default component.exports